export class functions{
  static getUnique(arr, comp) {
    const unique = arr
      .map(e => e[comp])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter(e => arr[e]).map(e => arr[e])
    return unique
  }
  static groupBy(arr, prop) {
    const map = new Map(Array.from(arr, obj => [obj[prop], []]))
    arr.forEach(obj => map.get(obj[prop]).push(obj))
    return Array.from(map.values())
  }
}